import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { useEffect, useRef } from 'react';

/**
 * Starts store playback once when `autoPlay` is enabled (e.g. after media UI is ready).
 */
export function usePlaybackAutoPlay(autoPlay: boolean) {
  const play = usePlaybackPlay();
  const startedRef = useRef(false);

  useEffect(() => {
    if (!autoPlay || startedRef.current) {
      return;
    }

    startedRef.current = true;
    void play();
  }, [autoPlay, play]);
}
